import { Eyebrow } from "../common/brand/Eyebrow";
import { ScheduledJob } from "@/types/common.types";
import useAnalyticsManager from "@/hooks/miscellaneous/useAnalyticsManager";
import { useEffect, useState } from "react";
import SearchInput from "../common/SearchInput";
import { useDebounceValue } from "usehooks-ts";
import { Button } from "../ui/button";
import Icon from "../common/Icon";
import { VisibilityState } from "@tanstack/react-table";
import MultiSelect from "../common/MultiSelectDropdown";
import { JobsListTable } from "./table";

type JobListProps = {
  onSelectJob: (job: ScheduledJob) => void;
  onCreateJob: () => void;
};
const JobList: React.FC<JobListProps> = ({ onSelectJob }) => {
  const { sendEvent } = useAnalyticsManager();
  useEffect(() => {
    sendEvent("home_screen_viewed");
  }, []);
  const [search, setSearch] = useState("");
  const [debouncedSearchValue] = useDebounceValue(search, 500);
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});

  const [columnOptions, setColumnOptions] = useState<
    Array<{ id: string; label: string }>
  >([]);
  const [initialSelectedColumns, setInitialSelectedColumns] = useState<
    string[]
  >([]);

  useEffect(() => {
    if (debouncedSearchValue) {
      sendEvent("job_search_initiated", {
        search_query: debouncedSearchValue,
        screen_name: "jobs list",
      });
    }
  }, [debouncedSearchValue]);
  const handleColumnChange = (selected: string[]) => {
    sendEvent("edit_columns_clicked");
    const newColumnVisibility = Object.fromEntries(
      columnOptions.map((option) => [option.id, selected.includes(option.id)])
    );
    setColumnVisibility(newColumnVisibility);
  };
  return (
    <>
      <div className="flex flex-col gap-2">
        <Eyebrow>[ HOME · JOBS ]</Eyebrow>
        <h1 className="font-display text-[34px] font-medium leading-[1.05] tracking-[-0.02em] text-brand-text">
          Home.
        </h1>
        <div className="flex flex-1 items-center justify-between">
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-brand-muted">
            Jobs
          </span>
          <div className="flex items-center gap-4">
            <SearchInput
              value={search}
              onChange={setSearch}
              placeholder="Search Dataset"
            />
            <div className="flex gap-3">
              {columnOptions.length > 0 && ( // Only show when options exist
                <MultiSelect
                  options={columnOptions}
                  initialSelected={initialSelectedColumns}
                  onChange={handleColumnChange}
                  trigger={
                    <Button
                      variant="outline"
                      leftIcon={<Icon name="edit" size={16} />}
                    >
                      Edit Column
                    </Button>
                  }
                  screen_name="jobs"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <JobsListTable
        onJobClick={onSelectJob}
        search={search}
        setSearch={setSearch}
        debouncedSearchValue={debouncedSearchValue}
        columnVisibility={columnVisibility}
        setColumnVisibility={setColumnVisibility}
        setColumnOptions={setColumnOptions}
        setInitialSelectedColumns={setInitialSelectedColumns}
      />
    </>
  );
};

export default JobList;
